import { identityApi } from '@commerce-identity-webcomponents/sdk';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import { ApiConfigService, ConfigService, ConsoleLogger } from '@nextgen-web-framework/core';
import { v5 as uuidv5 } from 'uuid';
import { LoginWrapperPropsTypes } from './types/propTypes';

export default function LoginWrapper(props: LoginWrapperPropsTypes) {
  const { replace } = useNextgenRouter();
  const {
    NEXT_PUBLIC_GLU_CLIENT_ID: clientId,
    NEXT_PUBLIC_GLU_BASE_URL: gluuBaseUrl,
    NEXT_PUBLIC_ACR_VALUE: defaultAcrValue,
    NEXT_PUBLIC_LANGUAGE,
    NEXT_PUBLIC_WEB_BASE_PATH,
  } = ConfigService.getConfigs();
  const tuples = ApiConfigService.getTuples();
  const defaultRedirectUri = `${ApiConfigService.getBaseUrl()}/comgluuoidc/v1/auth`;
  const defaultLanguague = NEXT_PUBLIC_LANGUAGE;

  const stateObj = {
    headers: tuples,
    redirectUri: `${NEXT_PUBLIC_WEB_BASE_PATH}`,
    amw_lng: props.amw_lng || defaultLanguague,
  };
  const defaultState = btoa?.(JSON.stringify(stateObj));
  const defaultNonce = uuidv5(`${Date.now()}`, uuidv5.URL);
  const {
    scope,
    responseType,
    state = defaultState,
    className = '',
    countryIso,
    loginHint,
    redirectUri = defaultRedirectUri,
    acrValues = defaultAcrValue as string,
    socialConnectRedirectUrl,
    preselectedExternalProvider,
    socialClientId = clientId,
    nonce = defaultNonce,
    responseMode,
    socialLinkFromMyAccount,
    prompt,
  } = props;

  const clickHandler = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      let data = {} as { jansKey?: string };
      if (socialLinkFromMyAccount) {
        data = await identityApi.createSocialLinkLoggedInJansKey(ApiConfigService.getBaseUrl());
      }

      const url = await identityApi.getAuthorizeUrl({
        gluuBaseUrl: gluuBaseUrl as string,
        redirectUri,
        clientId: socialClientId as string,
        nonce,
        acrValues,
        state,
        countryIso,
        loginHint,
        scope,
        responseType,
        socialConnectRedirectUrl,
        preselectedExternalProvider,
        responseMode,
        jansKey: data?.jansKey,
        prompt,
      });
      replace?.(url);
    } catch (error) {
      handleAuthorizationError(error as Error);
    }
  };

  const handleAuthorizationError = (error: Error) => {
    ConsoleLogger.error('Authorization error occurred:', error);
  };

  return (
    <div
      data-testid="loginWrapper-test-id"
      onClick={clickHandler}
      className={`login-wrapper ${className}`}
      role="presentation"
    >
      {props.children}
    </div>
  );
}
